export const PRESET_AVATARS = [
  {
    id: 'avatar-1',
    name: 'Universal Access',
    alt: 'Universal accessibility icon on deep navy background',
    src: '/avatars/avatar-1.svg',
    category: 'accessibility'
  },
  {
    id: 'avatar-2',
    name: 'Wheelchair',
    alt: 'Wheelchair icon on deep teal background',
    src: '/avatars/avatar-2.svg',
    category: 'accessibility'
  },
  {
    id: 'avatar-3',
    name: 'Hearing',
    alt: 'Ear icon on dark brown background',
    src: '/avatars/avatar-3.svg',
    category: 'accessibility'
  },
  {
    id: 'avatar-4',
    name: 'Vision',
    alt: 'Eye icon on almost black background',
    src: '/avatars/avatar-4.svg',
    category: 'accessibility'
  },
  {
    id: 'avatar-5',
    name: 'Neurodiversity',
    alt: 'Brain icon on deep indigo background',
    src: '/avatars/avatar-5.svg',
    category: 'accessibility'
  },
  {
    id: 'avatar-6',
    name: 'Inclusion',
    alt: 'Heart icon on deep purple background',
    src: '/avatars/avatar-6.svg',
    category: 'accessibility'
  },
  {
    id: 'avatar-7',
    name: 'Community',
    alt: 'Users icon on deep teal background',
    src: '/avatars/avatar-7.svg',
    category: 'accessibility'
  },
  {
    id: 'avatar-8',
    name: 'Sign Language',
    alt: 'Hand sign icon on deep red background',
    src: '/avatars/avatar-8.svg',
    category: 'accessibility'
  }
];
